<template>
  <div>
    <!-- NEW RECORD -->
    <div class="mb-2 mt-3 text-center">
      <v-btn
        color="primary"
        elevation="0"
        @click="SET_RECORD_FORM({}); SET_EDIT_MODE(false); SHOW_RECORD_FORM()"
      >
        إضافة تصنيف فرعي
        <v-icon class="mr-2">mdi-plus</v-icon>
      </v-btn>
    </div>

    <!-- CREATE / UPDATE FROM -->
    <record-form @update="fetchRecords()" />

    <!-- TABLE -->
    <v-data-table
      item-key="id"
      class="elevation-0 grey lighten-5"
      :loading="table.loading"
      :headers="table.headers"
      :items="records"
      loading-text="جاري تحميل البيانات"
      no-data-text="لا يوجد بيانات"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
    >
      <!-- CONTROLS -->
      <template v-slot:item.controls="{ item }">
        <v-btn
          small
          icon
          color="success"
          class="mx-2"
          @click="SET_RECORD_FORM(item); SET_EDIT_MODE(true); SHOW_RECORD_FORM()"
        >
          <v-icon>mdi-circle-edit-outline</v-icon>
        </v-btn>

        <v-btn
          small
          icon
          color="error"
          class="mx-2"
          @click="remove(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- PAGINATION -->
    <div class="text-center mt-1">
      <v-pagination
        total-visible="7"
        :value="parseInt(filters.page)"
        :length="totalPages"
        @input="SET_FILTERS({ ...filters, page: $event }); fetchRecords()"
      ></v-pagination>
    </div>
  </div>
</template>


<script>
import RecordForm from './RecordForm';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'sub-sections-table',
  props: ['section'],
  components: { RecordForm },

  data: function () {
    return {
      table: {
        headers: [
          {
            value: 'id',
            text: 'مسلسل التصنيف الفرعي'
          },
          {
            value: 'name',
            text: 'الاسم'
          },
          {
            value: 'articles_count',
            text: 'عدد المواد'
          },
          {
            value: 'created_at',
            text: 'تاريخ الإضافة'
          },
          {
            value: 'controls',
            text: 'اعدادات'
          },
        ],
        loading: false
      }
    }
  },


  computed: {
    ...mapState('subSections', ['records', 'filters', 'totalPages']
    )
  },


  watch: {
    section: {
      handler(section) {
        this.SET_SECTION(this.section);
        this.SET_FILTERS({ section_id: section.id, page: 1 });
        this.fetchRecords();
      },
      immediate: true
    }
  },


  methods: {
    ...mapMutations(
      'subSections',
      [
        'SHOW_RECORD_FORM',
        'SET_EDIT_MODE',
        'SET_RECORD_FORM',

        'SET_FILTERS',
        'SET_SECTION'
      ]
    ),

    fetchRecords() {
      this.table.loading = true;

      this.$store.dispatch('subSections/fetchRecords')
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب البيانات, يرجي التأكد من حالة الشبكة',
            color: 'accent'
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },

    async remove(selectedRecord) {
      const confirmMessageParams = [
        `حذف التصنيف الفرعي رقم ${selectedRecord.id}!`,
        `هل أنت متأكد من حذف التصنيف الفرعي '${selectedRecord.name}'؟`,
        { color: 'error' }
      ];
      if (!await this.$root.$confirm(...confirmMessageParams)) return;

      this.table.loading = true;

      this.$store.dispatch('subSections/delete', { recordId: selectedRecord.id })
        .then(() => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم حذف التصنيف الفرعي بنجاح',
            color: 'success'
          });
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر حذف التصنيف الفرعي',
            color: 'accent'
          });
        })
        .finally(() => {
          this.table.loading = false;
        });;
    }
  }
}
</script>
